import { createClient, SupabaseClient } from '@supabase/supabase-js';

// For new API keys (sb_publishable_): JWT verification fails due to ES256 mismatch with PostgREST
// For legacy anon key (JWT format): JWT verification works via HS256
// Use VITE_SUPABASE_ANON_KEY env var — set to legacy anon JWT for PostgREST compatibility
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || '';

const isConfigured = supabaseUrl && supabaseAnonKey;

export const supabase: SupabaseClient = isConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : (null as unknown as SupabaseClient);

// Helper to check if Supabase is configured
export const isSupabaseConfigured = () => isConfigured;